import {
    APP_VERSION_CHANGED,
    DEVICE_STATUS_CHANGED,
    ERROR_MODAL_PROPS_CHANGED,
    ERROR_MODAL_PROPS_RESET,
} from './types';
import AppVersionService from '../../services/AppVersionService';
import * as types from './types';

export const setAppVersion = version => ({
    type: APP_VERSION_CHANGED,
    payload: version,
});

export const fetchAppVersion = () => async dispatch => {
    try {
        const response = await AppVersionService.getAppVersion();

        const { info, item } = response;

        if (!info.success) {
            return;
        }

        const { version } = item;

        dispatch(setAppVersion(version));
    } catch (error) {
        console.error(error);
    }
};

export const setBarcodeScanned = value => ({
    type: types.BARCODE_SCANNED,
    payload: value,
});

// export const setBarcodeEntered = value => ({
//     type: types.BARCODE_ENTERED,
//     payload: value,
// });

export const changeDeviceStatus = payload => ({
    type: DEVICE_STATUS_CHANGED,
    payload,
});

export const changeErrorModalProps = payload => ({
    type: ERROR_MODAL_PROPS_CHANGED,
    payload,
});

export const resetErrorModalProps = payload => ({
    type: ERROR_MODAL_PROPS_RESET,
    payload,
});
